export default __webpack_public_path__ + "static/media/flag_serbia_and_montenegro.dc3a79d0.svg";